import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { all as getBrandings } from '../../../actions/branding';
import { asHtml } from '../../../helpers/markdown';
import { shouldFetchBrandings as _shouldFetchBrandings } from '../../../selectors/branding';
import { getFilterManufacturerPackaging } from '../../../utils/reselectors';

const GuaranteePackageHint = () => {
  const dispatch = useDispatch();
  const manufacturerPackaging = useSelector(getFilterManufacturerPackaging);
  const shouldFetchBrandings = useSelector(_shouldFetchBrandings);

  const actions = bindActionCreators({ getBrandings }, dispatch);

  useEffect(() => {
    if (shouldFetchBrandings) {
      actions.getBrandings();
    }
  }, []);

  if (!manufacturerPackaging) {
    return null;
  }

  let img;
  if (manufacturerPackaging?.logo?.file?.url) {
    img = (
      <img
        src={`${manufacturerPackaging.logo.file.url}?w=180&h=80&q=72`}
        srcSet={`${manufacturerPackaging.logo.file.url}?w=360&h=160&q=72 2x`}
        alt={manufacturerPackaging.name}
        className="m-b l-max-full"
      />
    );
  }

  return (
    <section className="page-section">
      {img}
      <div className="row">
        <div className="col-md-8">
          <div
            data-am-content=""
            dangerouslySetInnerHTML={{ __html: asHtml(manufacturerPackaging?.description || '') }}
          />
        </div>
      </div>
    </section>
  );
};

export default GuaranteePackageHint;
